module.exports = __webpack_public_path__ + "static/img_pledge_children_03M@2x-7fcafdfe2db750a8c2976bc92e991cf0.png";